import React, {
    useEffect,
    useState,
    useRef,
    useCallback,
    forwardRef,
} from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import PUnfollow from "./PUnfollow";
import moment from "moment";
import MetaTags from "react-meta-tags";
import Avatar from "./Avatar";
import {
    CARD_ERRORS,
    FOLLOW_STATUS,
    FOLLOW_TIER,
    PERIOD_TYPE,
    s3Link,
    TRANSACTION_TYPE,
} from "../utils/constants";
import useDidMountEffect from "../utils/useDidMountEffect";
import { captureException, captureMessage } from "@sentry/react";
import currency from "currency.js";
import { useDispatch } from "react-redux";
import {
    setAlert,
    setCreditCardForm,
    updateCcVerification,
} from "../../redux/actions";
import { Button } from "@mui/material";
import PageHeader from "../common/PageHeader";
import styled from "styled-components";
import { inFreeTiers } from "../utils/helper";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from "react-router-dom";

const PageHeaderWrapper = styled.div`
    padding-left: 37px;
    padding-right: 37px;

    @media (max-width: 767px) {
        padding-left: 15px;
        padding-right: 15px;
    }
`;

const Followed = forwardRef(
    (
        {
            following,
            setActiveFollowing,
            setRefetch,
            setActiveToFollow,
            isBusy = false,
            setIsBusy,
            setShowCcForm,
        },
        ref
    ) => {
        const dispatch = useDispatch();
        const [isLoading, setIsLoading] = useState(false);
        const [subscriptionDate, setSubscriptionDate] = useState("");
        const [subscriptionLabel, setSubscriptionLabel] = useState("");
        const [dateFormat, setDateFormat] = useState("Do MMM YYYY hh:mm:ss A");

        const handleDate = (follower) => {
            // convert subs time to local time
            const subscribedAt = moment.utc(follower.subscribed_at).local();
            const unfollowedAt = moment.utc(follower.unfollowed_at).local();

            const unfollowedYear = unfollowedAt.format("YYYY");

            const nowMonth = moment().format("MM");
            const nowDay = moment().format("DD");
            const nowYear = moment().format("YYYY");
            const nowTime = moment().format("HH:mm:ss");

            // const toCompareNow = moment(`${nowMonth}-${nowDay} ${nowTime}`, 'MM/DD HH:mm:ss')
            // const toCompareUnfollowedAt = moment(`${unfollowedAt.format('MM')}-${unfollowedAt.format('DD')} ${unfollowedAt.format('HH:mm:ss')}`, 'MM/DD HH:mm:ss')
            // const toCompareSubscribedAt = moment(`${subscribedAt.format('MM')}-${subscribedAt.format('DD')} ${subscribedAt.format('HH:mm:ss')}`, 'MM/DD HH:mm:ss')
            let date = "";
            let parsedDate = "";
            let month = "";
            let year = "";
            let periodType = "days";

            if (
                follower.status == FOLLOW_STATUS.ACTIVE &&
                !inFreeTiers(follower.tier)
            ) {
                if (follower.tier == FOLLOW_TIER.FREE_PLAN) {
                    setSubscriptionLabel(`Expires on: <br />`);
                } else {
                    if (!inFreeTiers(follower.tier)) {
                        setSubscriptionLabel(
                            `Renews to ${currency(
                                follower.following_information.creator
                                    .subscription_price
                            ).format({ precision: 2 })}<br />`
                        );
                    }
                }

                month = moment().add(1, "M").format("MM");
                if (moment().format("DD") < subscribedAt.clone().format("DD")) {
                    month = moment().format("MM");
                }

                year = moment().format("YYYY");
                if (
                    moment().format("MM") == 12 &&
                    moment().format("DD") < subscribedAt.clone().format("DD")
                ) {
                    year = year;
                } else if (
                    moment().format("MM") == 12 &&
                    moment().format("DD") >= subscribedAt.clone().format("DD")
                ) {
                    year = parseInt(year) + 1;
                    month = "01";
                }

                parsedDate = `${year}-${month}-${subscribedAt
                    .clone()
                    .format("DD")} ${subscribedAt.clone().format("HH:mm:ss")}`;
                date = `${moment(parsedDate.replace(/-/g, "/")).format(
                    dateFormat
                )}`;

                if (follower.tier == FOLLOW_TIER.FREE_PLAN) {
                    periodType =
                        follower.period_type == PERIOD_TYPE.DAY
                            ? "days"
                            : "months";
                    date = subscribedAt
                        .add(follower.free_period, periodType)
                        .format(dateFormat);
                }

                setSubscriptionDate(date);
            }

            if (follower.status == FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW) {
                setSubscriptionLabel(`Expires on:<br />`);

                let formatDate =
                    follower.tier == 1 ? "Do MMM YYYY" : dateFormat;

                // is current day less than subscription day
                if (moment().format("DD") < subscribedAt.format("DD")) {
                    month = moment().format("MM");
                    year = moment().format("YYYY");
                } else {
                    //   goes here
                    if (moment().format("MM") == 12) {
                        month = "01";
                        year = parseInt(moment().format("YYYY")) + 1; // year now + 1
                    } else {
                        // goes here
                        month = moment().add(1, "M").format("MM");
                        year = moment().format("YYYY");
                    }
                }

                parsedDate = `${year}-${month}-${subscribedAt.format(
                    "DD"
                )} ${subscribedAt.format("hh:mm:ss A")}`;
                date = `${moment(parsedDate.replace(/-/g, "/")).format(
                    formatDate
                )}`;

                setSubscriptionDate(date);
            }

            if (follower.status == FOLLOW_STATUS.UNSUBSCRIBED) {
                let formatDate =
                    follower.tier == 1 ? "Do MMM YYYY" : dateFormat;
                if (follower.expired_at) {
                    setSubscriptionLabel(`Expired on:<br />`);
                    setSubscriptionDate(
                        moment
                            .utc(follower.expired_at)
                            .local()
                            .format(formatDate)
                    );
                } else {
                    if (follower.unfollowed_at) {
                        setSubscriptionLabel(`Expired on:<br />`);
                        setSubscriptionDate(
                            moment
                                .utc(follower.unfollowed_at)
                                .local()
                                .add(1, "M")
                                .format(formatDate)
                        );
                    } else {
                        setSubscriptionLabel("");
                        setSubscriptionDate("Expired");
                    }
                }
            }
        };

        useEffect(() => {
            let mounted = true;
            handleDate(following);

            return () => {
                mounted = false;
            };
        }, [following]);

        useEffect(() => {
            let mounted = true;

            if (following.tier == 1) {
                setDateFormat("Do MMM YYYY");
            }

            return () => {
                mounted = false;
            };
        }, [following]);

        const handleUnfollow = (e, following) => {
            e.preventDefault();
            setActiveFollowing(following);
        };

        const handleFollow = async (e, following) => {
            e.preventDefault();
            setActiveToFollow(following);
            setIsLoading(true);
            let action =
                following.status == FOLLOW_STATUS.UNSUBSCRIBED
                    ? "followed"
                    : "re-followed";
            await axios
                .patch(`/api/followings/${following.id}`, {
                    action: "refollow",
                    user_id: following.pu,
                    transaction_type: TRANSACTION_TYPE.SUBSCRIPTION,
                })
                .then((response) => {
                    if (!response.data.success && response.data.url) {
                        window.location = response.data.url;
                        return;
                    }

                    setIsLoading(false);
                    setRefetch(true);

                    let message =
                        response.data.message ?? `User successfully ${action}`;

                    dispatch(
                        setAlert({
                            show: true,
                            body: message,
                            type: "success",
                        })
                    );
                })
                .catch((error) => {
                    console.error({ error });
                    setIsLoading(false);

                    if (error.response && error.response.status === 401) {
                        window.location = "/login";
                    }

                    if (error.response && error.response.status === 403) {
                        dispatch(
                            setAlert({
                                show: true,
                                title: "",
                                body: error.response.data.message,
                                type: "error",
                            })
                        );
                        return;
                    }

                    if (
                        error.response &&
                        [404, 402].includes(error.response.status)
                    ) {
                        if (error.response.data.error === CARD_ERRORS.NO_CARD) {
                            setShowCcForm(true, following);
                            dispatch(
                                setAlert({
                                    show: true,
                                    title: "",
                                    body:
                                        error.response.data.message ||
                                        "Please add your card details",
                                    type: "error",
                                })
                            );
                            return;
                        } else if (
                            error.response.data.error ===
                            CARD_ERRORS.NEEDS_VALIDATION
                        ) {
                            dispatch(
                                updateCcVerification({
                                    showVerify: true,
                                })
                            );
                            return;
                        } else {
                            setShowCcForm(true, following);
                            dispatch(
                                setAlert({
                                    show: true,
                                    title: "",
                                    body:
                                        error.response.data.reason ||
                                        "Please add your card details",
                                    type: "error",
                                })
                            );
                            return;
                        }
                    } else {
                        dispatch(
                            setAlert({
                                show: true,
                                title: "",
                                body: "Failed to process request",
                                type: "error",
                            })
                        );
                    }
                });
        };

        const Price = ({ following }) => {
            if (following.tier == 3 || following.tier == 2) {
                return currency(following.amount).format({ precision: 2 });
            } else if (following.tier == 0) {
                if (following.amount > 0) {
                    return currency(following.amount).format({ precision: 2 });
                } else if (
                    following.following_information.creator &&
                    following.following_information.creator.subscription_price
                ) {
                    return currency(
                        following.following_information.creator
                            .subscription_price
                    ).format({ precision: 2 });
                }
            }

            return currency(following.subscription_price).format({
                precision: 2,
            });
        };

        return (
            <li ref={ref}>
                <div className="ref-new">
                    <div
                        className="img-div"
                        style={
                            following.following_information.cover_pic
                                ? {
                                      backgroundImage: `url("${s3Link}/${
                                          following.following_information.id
                                      }/cover_photo.jpg?t=${
                                          following.following_information
                                              .cover_photo_updated_at
                                              ? following.following_information
                                                    .cover_photo_updated_at
                                              : new Date().valueOf()
                                      }")`,
                                      backgroundSize: "cover",
                                      backgroundRepeat: "no-repeat",
                                      width:
                                          $(".ref-new") && $(".ref-new").width()
                                              ? parseFloat(
                                                    $(".ref-new").width()
                                                )
                                              : "auto",
                                      height:
                                          $(".ref-new") && $(".ref-new").width()
                                              ? parseFloat(
                                                    $(".ref-new").width()
                                                ) / 2
                                              : "auto",
                                      borderRadius: "6px 6px 0 0",
                                  }
                                : {
                                      width:
                                          $(".ref-new") && $(".ref-new").width()
                                              ? parseFloat(
                                                    $(".ref-new").width()
                                                )
                                              : "auto",
                                      height:
                                          $(".ref-new") && $(".ref-new").width()
                                              ? parseFloat(
                                                    $(".ref-new").width()
                                                ) / 2
                                              : "auto",
                                      borderRadius: "6px 6px 0 0",
                                      backgroundColor: "none",
                                  }
                        }
                    ></div>
                    <div className="cover-div">
                        <div className="cont-one following-details">
                            <div className="usr-img">
                                {following.following_information ? (
                                    <Avatar
                                        pu={following.following_information}
                                        story={!following.unfollowed_at}
                                        size="95"
                                    />
                                ) : null}
                            </div>
                            <p>
                                {following.following_information &&
                                following.following_information.login ? (
                                    <span>
                                        {following.following_information
                                            .firstname ?? ""}{" "}
                                        {following.following_information
                                            .lastname ?? ""}
                                        <br />
                                    </span>
                                ) : (
                                    ""
                                )}
                                <span>
                                    <a
                                        href={`${process.env.MIX_APP_URL}/${following.following_information.login}`}
                                    >
                                        {following.following_information.login}
                                    </a>
                                </span>
                                <br />
                                <span>Subscription: </span>
                                {[
                                    FOLLOW_TIER.FREE,
                                    FOLLOW_TIER.FREE_PLAN,
                                    FOLLOW_TIER.FREE_FOLLOW,
                                ].includes(following.tier) &&
                                following.status !=
                                    FOLLOW_STATUS.UNSUBSCRIBED ? (
                                    <b style={{ color: "#ea4b95" }}>FREE</b>
                                ) : (
                                    <b>
                                        <Price following={following} />
                                    </b>
                                )}
                            </p>

                            <p className="subscribed_at">
                                Started on:
                                <br />{" "}
                                <b>
                                    {moment
                                        .utc(following.subscribed_at)
                                        .local()
                                        .format(dateFormat)}
                                </b>
                            </p>

                            {following.following_information.creator &&
                                following.following_information.creator
                                    .pause_status == 1 && (
                                    <p className="following_paused">
                                        <span>ACCOUNT PAUSED</span>
                                    </p>
                                )}

                            {following.status ==
                                FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW &&
                                following.unfollowed_at && (
                                    <p className="unfollowed_at">
                                        Unfollowed on:
                                        <br />{" "}
                                        <b>
                                            {moment
                                                .utc(following.unfollowed_at)
                                                .local()
                                                .format(dateFormat)}
                                        </b>
                                    </p>
                                )}
                        </div>
                        {!inFreeTiers(following.tier) ? (
                            <div className="cont-two subscription-cont">
                                <ul className="list-unstyled">
                                    <li className="expiry_date">
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: subscriptionLabel,
                                            }}
                                        />
                                        <b>{subscriptionDate}</b>
                                    </li>
                                </ul>
                            </div>
                        ) : null}

                        <div className="foll-btn">
                            {following.status == FOLLOW_STATUS.UNSUBSCRIBED ||
                            following.status ==
                                FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW ? (
                                <div className="my-4">
                                    {following.tier == FOLLOW_TIER.PROMO_PLAN &&
                                    following.status ==
                                        FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW ? (
                                        ""
                                    ) : (
                                        <Button
                                            variant="contained"
                                            className="refollow-btn"
                                            disabled={isLoading || isBusy}
                                            onClick={(e) =>
                                                handleFollow(e, following)
                                            }
                                        >
                                            {isLoading
                                                ? "Following..."
                                                : following.status ==
                                                  FOLLOW_STATUS.UNSUBSCRIBED
                                                ? "Follow"
                                                : "Refollow"}
                                        </Button>
                                    )}
                                    {following.tier != FOLLOW_TIER.PROMO_PLAN &&
                                        following.status ==
                                            FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW && (
                                            <div className="refollow_text mt-1">
                                                By clicking the "Refollow"
                                                button, your subscription will
                                                be reinstated with no extra
                                                charge now. The next charge will
                                                be at the scheduled renewal date
                                            </div>
                                        )}
                                </div>
                            ) : (
                                <Button
                                    variant="outlined"
                                    className="unfollow-btn"
                                    onClick={(e) =>
                                        handleUnfollow(e, following)
                                    }
                                >
                                    Unfollow
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </li>
        );
    }
);

const FollowingGlobal = () => {
    const dispatch = useDispatch();
    const [followings, setFollowings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [activeFollowing, setActiveFollowing] = useState({});

    const [key, setKey] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [refetch, setRefetch] = useState(false);
    const [pageChange, setPageChange] = useState(0);
    const [totalActive, setTotalActive] = useState(0);
    const [totalExpired, setTotalExpired] = useState(0);
    const [totalAll, setTotalAll] = useState(0);
    const [totalPaid, setTotalPaid] = useState(0);
    const [totalFree, setTotalFree] = useState(0);

    // const [showCcForm, setShowCcForm] = useState(false);
    const [addCardStatus, setAddCardStatus] = useState(false);
    const [activeToFollow, setActiveToFollow] = useState({});

    const perPage = 15;

    const setShowCcForm = (payload, pu) => {
        dispatch(
            setCreditCardForm({
                show: payload,
                prefilled: true,
                closeOnly: true,
                intent: "follow",
                username: pu.following_information.login,
            })
        );
    };

    const observer = useRef();
    const lastFollowingElement = useCallback(
        (node) => {
            if (isLoading) return;
            if (observer.current) {
                observer.current.disconnect();
            }

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMore) {
                    setCurrentPage((currentPage) => currentPage + 1);
                    setPageChange((pageChange) => pageChange + 1);
                }
            });

            if (node) observer.current.observe(node);

            return () => {
                observer.current.disconnect();
            };
        },
        [isLoading, hasMore]
    );

    useEffect(() => {
        let mounted = true;

        if (refetch) {
            setCurrentPage(1);
            setPageChange((pageChange) => pageChange + 1);
        }

        return () => {
            mounted = false;
        };
    }, [refetch]);

    const getFollowings = async (source = "new") => {
        setIsLoading(true);
        await axios
            .get(`/api/followings`, {
                params: {
                    type: key,
                    page: currentPage,
                    per_page: perPage,
                },
            })
            .then((response) => {
                setHasMore(
                    response.data.data.length > 0 &&
                        response.data.data.length >= perPage
                );
                if (source == "new") {
                    setFollowings(response.data.data);
                } else {
                    const followingIds = new Set(
                        followings.map((following) => following.id)
                    );
                    const merged = [
                        ...followings,
                        ...response.data.data.filter(
                            (d) => !followingIds.has(d.id)
                        ),
                    ];

                    setFollowings(merged);
                }
                setRefetch(false);
            })
            .catch((error) => {
                captureMessage(error);

                if (error.response.status === 401) {
                    window.location = "/login";
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (currentPage > 1) {
            getFollowings("loadMore");
        } else {
            getFollowings("new");
        }
        // console.log('** page change: ',{pageChange})
    }, [pageChange]);

    useEffect(() => {
        let mounted = true;
        if (activeFollowing && Object.keys(activeFollowing).length > 0) {
            setShowModal(true);
        }

        return () => {
            mounted = false;
        };
    }, [activeFollowing]);

    const handleStatus = (status) => {
        if (status) {
            setCurrentPage(1);
            setPageChange((pageChange) => pageChange + 1);
        }
    };

    const getTotals = () => {
        axios
            .get("/api/followings/totals")
            .then((response) => {
                setTotalFree(response.data.free);
                setTotalPaid(response.data.paid);
                setTotalExpired(response.data.expired);
                setTotalAll(response.data.all);
            })
            .catch((error) => {
                console.error({ error });
                if (error.response.status === 401) {
                    window.location = "/login";
                }
            });
    };

    useEffect(() => {
        let mounted = true;
        getTotals();

        return () => {
            mounted = false;
        };
    }, []);

    useDidMountEffect(() => {
        setCurrentPage(1);
        setPageChange((pageChange) => pageChange + 1);
    }, [key]);

    const setPaymentShow = () => {
        setShowCcForm(false);
    };

    useEffect(() => {
        if (!showModal) {
            setActiveFollowing({});
        }
    }, [showModal]);

    return (
        <>
            <div className="following-container">
                <MetaTags>
                    <title>
                        Following &#8211; Best way to make money as an
                        influencer for your exclusive content
                    </title>
                    <meta
                        name="description"
                        content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid."
                    />
                </MetaTags>
                <div className="following-panel-wrapper">
                    <PageHeaderWrapper>
                        <PageHeader title="Subscriptions and Following" />
                    </PageHeaderWrapper>
                    <div className="following-panel-body">
                        <div className="following-panel-content">
                            <Tabs
                                defaultActiveKey="all"
                                transition={false}
                                id="subscriptionTabs"
                                onSelect={(k) => setKey(k)}
                            >
                                <Tab
                                    eventKey="all"
                                    title={`All (${totalAll})`}
                                />
                                <Tab
                                    eventKey="paid"
                                    title={`Paid (${totalPaid})`}
                                />
                                <Tab
                                    eventKey="free"
                                    title={`Free (${totalFree})`}
                                />
                                <Tab
                                    eventKey="expired"
                                    title={`Expired (${totalExpired})`}
                                />
                            </Tabs>

                            <div>
                                <div
                                    css={css`
                                        text-align: center;
                                        padding: 15px;
                                    `}
                                >
                                    (Click{" "}
                                    <Link to="/payment-details">here</Link> to
                                    Add/Edit your payment method)
                                </div>
                                <ul className="foll-bx-lst">
                                    {followings.map((following, index) => {
                                        if (followings.length === index + 3) {
                                            return (
                                                <Followed
                                                    following={following}
                                                    ref={lastFollowingElement}
                                                    key={`following-${index}`}
                                                    setActiveFollowing={
                                                        setActiveFollowing
                                                    }
                                                    setRefetch={setRefetch}
                                                    setActiveToFollow={
                                                        setActiveToFollow
                                                    }
                                                    isBusy={isLoading}
                                                    setShowCcForm={
                                                        setShowCcForm
                                                    }
                                                />
                                            );
                                        } else {
                                            return (
                                                <Followed
                                                    following={following}
                                                    key={`following-${index}`}
                                                    setActiveFollowing={
                                                        setActiveFollowing
                                                    }
                                                    setRefetch={setRefetch}
                                                    setActiveToFollow={
                                                        setActiveToFollow
                                                    }
                                                    isBusy={isLoading}
                                                    setShowCcForm={
                                                        setShowCcForm
                                                    }
                                                />
                                            );
                                        }
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <PUnfollow
                    show={showModal}
                    setShow={setShowModal}
                    activeFollowing={activeFollowing}
                    handleStatus={handleStatus}
                />
            )}
        </>
    );
};

export default FollowingGlobal;
